export const STATUS = {
  0: 'Active',
  1: 'Retired',
  2: 'Pending'
};

export type StatusKeys = keyof typeof STATUS;

export const WEB_MENU = {
 'WEB-FR': 'WEB-FR',
 'WEB-CO': 'WEB-CO'
};
export type WebMenuKeys = keyof typeof WEB_MENU;

export const PRICE_OPTION = {
  0: 'Pricing options are allowed',
  1: 'More than one item allowed per screen',
  2: 'Products may have their price entered manually'
};

export type PriceOptionKeys = keyof typeof PRICE_OPTION;

export const TOPPING_SUBSTITUTIONS = {
  0: '0 - N/A',
  1: '1 - Meat Substitutions',
  2: '2 - Vegetables Substitutions',
  9: '9 - No Substitutions Allowed'
};

export const ALLOW_TOPPING_TYPE = {
  0: '0 - Any Topping Is Allowed',
  2: '2 - Only Combo Toppings Are Allowed',
  4: '4 - Do not Display in Order Entry'
};

export type AllowTopTypeKeys = keyof typeof ALLOW_TOPPING_TYPE;

export enum MENU_FILTERS {
  ACTIVATE = 'ACTIVATE',
  EXTRACT = 'EXTRACT',
  PUBLISH = 'PUBLISH',
};

export enum MENU_STATUS {
  ACTIVE = 0,
  PENDING = 2,
};

export enum SPEC_STATUS {
  ACTIVE = '0',
  RETIRED = '1',
  INACTIVE = '2',
};

export enum COUPON_GROUP_STATUS {
  ACTIVE = 0,
  PENDING = 2,
};

export enum COUPON_GROUP_FILTERS {
  ACTIVATE = 'ACTIVATE',
  EXTRACT = 'EXTRACT',
};

export enum STORE_TYPE {
  NA = 0,
  MARKET = 1,
  EQUITY = 2,
  OTHER = 3,
};


export enum CLASS_STATUS {
  ACTIVE = '0',
  RETIRED = '1',
  INACTIVE = '2',
};

export const DAY_FILTER_TYPE = {
  'TODAY' : 0,
  'YESTERDAY' : 1,
  'TWO_DAYS' : 2,
  'THREE_DAYS' : 3,
  'FOUR_DAYS' : 4,
  'FIVE_DAYS' : 5,
  'SIX_DAYS' : 6,
  'SEVEN_DAYS' : 7,
};

export type DayFilterTypeKeys = keyof typeof DAY_FILTER_TYPE;